import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "modal",
    "playerName",
    "actions",
    "incoming",
    "details",
    "assistField",
    "playerId",
    "kind",
    "assistPlayerId",
    "assistOption",
    "playerInId",
    "incomingButton",
    "incomingGroup",
    "incomingEmpty",
    "incomingSummary",
    "minute",
    "backLink"
  ]

  connect() {
    if (this.hasPlayerInIdTarget) this.playerInIdTarget.disabled = true
    if (this.hasAssistPlayerIdTarget) this.assistPlayerIdTarget.disabled = true
  }

  open(event) {
    const button = event.currentTarget
    this.selectedPlayerId = button.dataset.playerId
    this.playerIdTarget.value = this.selectedPlayerId
    const name = button.dataset.playerName
    this.playerNameTargets.forEach((element) => {
      element.textContent = element.dataset.template.replace("__NAME__", name)
    })
    if (this.hasMinuteTarget) this.minuteTarget.value = ""
    this.playerInIdTarget.value = ""
    this.playerInIdTarget.disabled = true
    this.resetAssist()
    this.showStep("actions")
    $(this.modalTarget).modal("show")
  }

  choose(event) {
    const kind = event.currentTarget.dataset.kind
    this.kindTarget.value = kind
    const substitution = kind === "substitution"
    const goal = kind === "goal"

    this.playerInIdTarget.value = ""
    this.playerInIdTarget.disabled = !substitution
    this.incomingSummaryTarget.classList.add("d-none")
    this.resetAssist()

    if (goal && this.hasAssistFieldTarget) {
      this.assistFieldTarget.classList.remove("d-none")
      this.assistPlayerIdTarget.disabled = false
      this.filterAssist()
    }

    if (substitution) {
      this.filterIncoming()
      this.showStep("incoming")
      return
    }

    this.showStep("details")
  }

  chooseIncoming(event) {
    const button = event.currentTarget
    this.playerInIdTarget.disabled = false
    this.playerInIdTarget.value = button.dataset.playerId
    this.incomingSummaryTarget.textContent = this.incomingSummaryTarget.dataset.template.replace("__NAME__", button.dataset.playerName)
    this.incomingSummaryTarget.classList.remove("d-none")
    this.showStep("details")
  }

  back(event) {
    event.preventDefault()
    if (!this.detailsTarget.classList.contains("d-none") && this.kindTarget.value === "substitution") {
      this.showStep("incoming")
      return
    }
    this.showStep("actions")
  }

  showStep(name) {
    this.actionsTarget.classList.toggle("d-none", name !== "actions")
    this.incomingTarget.classList.toggle("d-none", name !== "incoming")
    this.detailsTarget.classList.toggle("d-none", name !== "details")
    if (this.hasBackLinkTarget) this.backLinkTarget.classList.toggle("d-none", name === "actions")
  }

  filterIncoming() {
    this.incomingButtonTargets.forEach((button) => {
      button.classList.toggle("d-none", button.dataset.playerId === this.selectedPlayerId)
    })
    this.incomingGroupTargets.forEach((group) => {
      const visible = Array.from(group.querySelectorAll(".match-event-incoming")).some((button) => !button.classList.contains("d-none"))
      group.classList.toggle("d-none", !visible)
    })
    const anyVisible = this.incomingButtonTargets.some((button) => !button.classList.contains("d-none"))
    if (this.hasIncomingEmptyTarget) this.incomingEmptyTarget.classList.toggle("d-none", anyVisible)
  }

  filterAssist() {
    if (!this.hasAssistOptionTarget) return

    this.assistOptionTargets.forEach((option) => {
      const hide = option.value === this.selectedPlayerId
      option.hidden = hide
      option.disabled = hide
    })
  }

  resetAssist() {
    if (!this.hasAssistPlayerIdTarget) return

    this.assistPlayerIdTarget.value = ""
    this.assistPlayerIdTarget.disabled = true
    if (this.hasAssistFieldTarget) this.assistFieldTarget.classList.add("d-none")
  }
}
